<template>
  <div>
    <!-- no-close-on-backdrop
      no-close-on-esc -->
    <b-modal
      ref="modal-rrhh-discount"
      :title="$t(getTitleModal)"
      modal-class="modal-primary"
      hide-footer
      @hidden="$emit('hideModal')"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
    >
      <!-- <div class="mb-1 mt-1" v-if="modalData.id != null">
        <b-row>
          <b-col md="12" v-if="approved">
            <b-alert show variant="success">
              <div class="alert-body">
                <feather-icon class="mr-25" icon="CheckCircleIcon" />
                <span class="ml-25">El viatico esta aprobado.</span>
              </div>
            </b-alert>
          </b-col>
          <b-col sm="6">
            <b-input-group class="mb-1">
              <template #prepend>
                <b-input-group-text class="prepend__width">
                  <strong>CODE</strong>
                </b-input-group-text>
              </template>
              <b-form-input :value="modalData.code" disabled />
            </b-input-group>
          </b-col>
          <b-col sm="6">
            <b-input-group class="mb-1">
              <template #prepend>
                <b-input-group-text class="prepend__width">
                  <strong>NAME</strong>
                </b-input-group-text>
              </template>
              <b-form-input :value="modalData.personal_name" disabled />
            </b-input-group>
          </b-col>
        </b-row>
      </div> -->
      <!-- <div class="scroll-kanban"> -->
      <ValidationObserver ref="ref-validation-discount">
        <b-row>
          <!-- <b-col v-if="isCeo" :sm="isCeo ? '6' : '12'">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="payment_date"
              >
                <b-form-group
                  :label="$t('Start Date')"
                  label-for="start_date"
                  :state="errors[0] ? false : null"
                >
                  <kendo-datepicker
                    id="start_date"
                    v-model="modalData.date"
                    v-mask="'##/##/####'"
                    :class="[
                      ' form-control',
                      { 'text-white': isDarkSkin },
                      errors[0] ? 'border-danger' : '',
                    ]"
                    :format="'MM/dd/yyyy'"
                  />
                </b-form-group>
              </ValidationProvider>
            </b-col> -->

          <!-- Areas -->
          <b-col lg="6">
            <b-row class="border-right">
              <b-col lg="12" md="12" sm="12">
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  name="area_id"
                >
                  <b-form-group
                    :label="$t('Area')"
                    label-for="area_id"
                    :state="errors[0] ? false : null"
                  >
                    <v-select
                      id="area_id"
                      v-model="form.area_id"
                      :options="areas"
                      label="name"
                      :disabled="inputDisable"
                      :reduce="(area) => area.id"
                      @input="getEmployeeByArea(null)"
                    />
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <!-- Employee -->
              <b-col lg="12" md="12" sm="12">
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  name="employee_id"
                >
                  <b-form-group
                    :label="$t('Employee')"
                    label-for="employee_id"
                    :state="errors[0] ? false : null"
                  >
                    <v-select
                      id="employee_id"
                      v-model="form.employee_id"
                      :options="employees"
                      :disabled="inputDisable || !form.area_id"
                      label="full_name"
                      :reduce="(employee) => employee.id"
                    />
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <!-- Discount Types -->
              <b-col lg="12" md="12" sm="12">
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  name="discount_type_id"
                >
                  <b-form-group
                    :label="$t('Discount Type')"
                    label-for="discount_type_id"
                    :state="errors[0] ? false : null"
                  >
                    <v-select
                      id="discount_type_id"
                      v-model="form.discount_type_id"
                      :options="discount_types"
                      label="name"
                      :disabled="
                        modalData.action == 'approve' ||
                        modalData.action == 'anulle' ||
                        localOrigin === 'adelanto'
                      "
                      :reduce="(dt) => dt.id"
                    />
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col v-if="localOrigin === 'adelanto'" lg="12" md="12" sm="12">
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  name="motivo_adelanto_id"
                >
                  <b-form-group
                    label-for="motivo_adelanto_id"
                    :state="errors[0] ? false : null"
                  >
                    <template #label>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <span>{{ $t("Motivo Adelanto") }}</span>
                        <feather-icon
                          icon="PlusIcon"
                          @click.stop="showModalMotivoAdelanto = true"
                          size="20"
                          class="text-primary cursor-pointer"
                        />
                      </div>
                    </template>
                    <v-select
                      id="motivo_adelanto_id"
                      v-model="form.motivo_adelanto_id"
                      :options="motivos_adelanto"
                      label="name"
                      :disabled="
                        modalData.action == 'approve' ||
                        modalData.action == 'anulle'
                      "
                      :reduce="(dt) => dt.id"
                    />
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col cols="12">
                <b-form-group
                  label="Sustento (opcional):"
                  label-for="archivo-trabajo"
                >
                  <b-form-file
                    v-if="!form.sustentoUrl"
                    id="archivo-trabajo"
                    v-model="form.sustento"
                    placeholder="Seleccione un archivo..."
                    drop-placeholder="Suelte el archivo aquí..."
                    browse-text="Buscar"
                    class="w-100"
                    :disabled="form.sustentoUrl"
                  ></b-form-file>

                  <div
                    v-if="form.sustentoUrl"
                    class="mt-1 d-flex align-items-center justify-content-between"
                  >
                    <b-link :href="form.sustentoUrl" target="_blank">
                      <feather-icon icon="FileIcon" class="text-primary" /> Ver
                      sustento
                    </b-link>
                    <b-button
                      v-if="modalData.action === 'edit'"
                      size="sm"
                      variant="outline-danger"
                      @click="deleteSustento"
                    >
                      <feather-icon
                        icon="TrashIcon"
                        class="text-danger"
                      ></feather-icon>
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>

              <!-- Observation -->
              <b-col md="12" lg="12">
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required|max:200"
                  name="observation"
                >
                  <b-form-group
                    :label="$t('Observation')"
                    label-for="observation"
                    :state="errors[0] ? false : null"
                  >
                    <b-form-textarea
                      v-model="form.observation"
                      rows="3"
                      :class="{ 'border-danger': errors[0] }"
                      :disabled="
                        modalData.action == 'approve' ||
                        modalData.action == 'anulle'
                      "
                    />
                  </b-form-group>
                </ValidationProvider>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="6">
            <b-row>
              <!-- Total -->
              <b-col lg="6" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="total"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('Amount')"
                    label-for="total"
                    :state="errors[0] ? false : null"
                  >
                    <money
                      id="total"
                      v-model="form.total"
                      v-bind="moneyConfig"
                      class="form-control w-100 form-control-md"
                      :disabled="
                        modalData.action == 'approve' ||
                        modalData.action == 'anulle'
                      "
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Quotas -->
              <b-col lg="6" md="6" sm="12">
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  name="quotas"
                >
                  <b-form-group
                    :label="$t('Quotas')"
                    label-for="quotas"
                    :state="errors[0] ? false : null"
                  >
                    <v-select
                      id="quotas"
                      v-model="form.quotas"
                      :options="quotas"
                      :disabled="
                        modalData.action == 'approve' ||
                        modalData.action == 'anulle'
                      "
                    />
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <!-- Fecha Primer Pago -->
              <b-col lg="6" md="6" sm="12">
                <ValidationProvider name="fecha_primer_pago" rules="required">
                  <b-form-group
                    label="Fecha Primer Pago"
                    label-for="fecha_primer_pago"
                  >
                    <flat-pickr
                      ref="picker"
                      v-model="form.fecha_primer_pago"
                      class="form-control"
                      :config="pickerConfig"
                      :disabled="
                        modalData.action == 'approve' ||
                        modalData.action == 'anulle'
                      "
                    />
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col lg="12" v-if="form.fractions.length > 0">
                <h4 class="mt-1 mb-1">{{ $t("Discount Schedule") }}</h4>
                <hr />
                <b-row
                  v-for="(fraction, index) in form.fractions"
                  :key="index"
                  class="mb-1 align-items-center"
                >
                  <b-col cols="6">
                    <span> #{{ index + 1 }} </span>
                    <feather-icon
                      icon="CalendarIcon"
                      size="20"
                      class="text-success ml-1"
                    />
                    <span> {{ fraction.formatted_date }} </span>
                  </b-col>

                  <b-col cols="6">
                    <validation-provider name="total" rules="required">
                      <money
                        id="total"
                        v-model="fraction.amount_fraction"
                        v-bind="moneyConfig"
                        class="form-control w-100 form-control-md"
                        :disabled="
                          modalData.action == 'approve' ||
                          modalData.action == 'anulle'
                        "
                      />
                    </validation-provider>
                  </b-col>
                </b-row>

                <span
                  class="text-danger"
                  v-if="sumAmountFractions !== form.total"
                >
                  La suma de las cuotas no coincide con el total.
                </span>
              </b-col>
            </b-row>
          </b-col>
          <!-- Observation Approve -->
          <b-col
            md="12"
            lg="12"
            v-if="
              modalData.action == 'approve' ||
              (modalData.action == 'anulle' && localOrigin === 'descuento')
            "
          >
            <ValidationProvider
              v-slot="{ errors }"
              rules="required|max:200"
              name="observation_approve"
            >
              <b-form-group
                :label="
                  modalData.action == 'approve'
                    ? $t('Observation Approve')
                    : $t('Observation Anulle')
                "
                label-for="observation_approve"
                :state="errors[0] ? false : null"
              >
                <b-form-textarea
                  id="observation_approve"
                  v-model="form.observation_approve"
                  rows="3"
                  :class="{ 'border-danger': errors[0] }"
                />
              </b-form-group>
            </ValidationProvider>
          </b-col>
        </b-row>
      </ValidationObserver>

      <!-- </div> -->
      <div class="text-center mt-1">
        <b-button
          v-if="modalData.id == null"
          @click="insertDiscount"
          variant="outline-success"
          :disabled="sumAmountFractions !== form.total"
          >{{ $t("REGISTER") }}</b-button
        >
        <b-button
          v-if="modalData.action == 'approve'"
          variant="outline-info"
          @click="approveDiscount"
          >{{ $t("APPROVE") }}</b-button
        >
        <b-button
          v-if="modalData.action == 'edit'"
          variant="outline-warning"
          @click="editDiscount"
          >{{ $t("UPDATE") }}</b-button
        >
        <b-button
          v-if="modalData.action == 'anulle'"
          variant="outline-danger"
          @click="anulleDiscount"
          >{{ $t("ANULLE") }}</b-button
        >
      </div>
    </b-modal>
    <MotivoAdelantoModal
      v-if="showModalMotivoAdelanto"
      @hidden="
        () => {
          showModalMotivoAdelanto = false;
          getMotivosAdelantoSueldo();
        }
      "
    />
  </div>
</template>

<script>
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import { mapGetters } from "vuex";
import modalMixin from "@/mixins/modal";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import DiscountsService from "@/views/commons/discounts/services/discounts.service.js";
import AdelantoService from "@/views/rrhh/views/payroll/components/adelanto-sueldo/services/adelanto.sueldo.service.js";
import MotivosAdelantoSueldoService from "@/views/rrhh/views/payroll/components/adelanto-sueldo/services/motivos.adelanto.sueldo.service.js";
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";
import MotivoAdelantoModal from "@/views/rrhh/views/payroll/components/adelanto-sueldo/components/MotivoAdelantoModal.vue";
import viaticService from "@/views/monitoring/views/viatic/services/viatic.service.js";

export default {
  mixins: [modalMixin],
  components: {
    flatPickr,
    MotivoAdelantoModal,
  },
  props: {
    modalData: {
      type: Object,
      require: true,
    },
    origin: {
      type: String,
      default: "descuento",
    },
  },
  data() {
    return {
      moneyConfig: {
        decimal: ".",
        thousands: ",",
        prefix: "S/.",
        precision: 2,
        masked: false,
      },
      localOrigin: { ...this.origin },
      form: {
        id: null,
        area_id: null,
        employee_id: null,
        discount_type_id: null,
        total: 0,
        quotas: 3,
        observation: null,
        observation_approve: null,
        fractions: [],
        user_id: null,
        fecha_primer_pago: moment()
          .add(1, "months")
          .date(5)
          .format("DD-MM-YYYY"),
        motivo_adelanto_id: null,
        sustento: null,
        sustentoUrl: null,
      },
      caja_automatica_data: {
        tipo_personal: null,
        caja_motivo: null,
        caja_submotivo: null,
      },
      disabled: false,
      approved: false,
      discount_types: [],
      motivos_adelanto: [],
      areas: [],
      employees: [],
      quotas: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24,
      ],
      pickerConfig: {
        dateFormat: "d-m-Y",
        onChange: this.onDateChange,
      },
      showModalMotivoAdelanto: false,
      suppressEvents: true, // Evita que se recalculen las fracciones al iniciar el modal
    };
  },
  mounted() {
    this.toggleModal("modal-rrhh-discount");
  },
  async created() {
    try {
      this.addPreloader();

      const shouldFetchById = this.modalData.id != null;
      const hasDiscountType = this.modalData.discount_type_id !== null;

      await this.getAreas();
      await this.getDiscountTypes();

      if (this.origin === "adelanto") {
        await this.getMotivosAdelantoSueldo();
      }

      if (shouldFetchById) {
        this.form.id = this.modalData.id;

        if (this.origin === "adelanto") {
          await this.getAdelantoById();
        } else {
          await this.getDiscountById();
        }
      } else if (!shouldFetchById && hasDiscountType) {
        this.form.discount_type_id = this.modalData.discount_type_id;
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.removePreloader();
      this.suppressEvents = false; // Permite el cálculo de fracciones después de la carga inicial
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    getTitleModal() {
      switch (this.modalData.action) {
        case "approve":
          return "APPROVE DISCOUNT";
        case "edit":
          return this.localOrigin === "adelanto"
            ? "EDITAR ADELANTO DE SUELDO"
            : "EDIT DISCOUNT";
        case "anulle":
          return "ANULLE DISCOUNT";
        default:
          return this.localOrigin === "adelanto"
            ? "REGISTRAR ADELANTO SUELDO"
            : "REGISTER DISCOUNT";
      }
    },
    inputDisable() {
      return (
        this.modalData.action == "approve" ||
        this.modalData.action == "edit" ||
        this.modalData.action == "anulle"
      );
    },
    esAdelantoSueldo() {
      return this.localOrigin === "adelanto";
    },
    sumAmountFractions() {
      if (this.form.fractions.length > 0) {
        const total = this.form.fractions.reduce(
          (acc, fraction) => acc + parseFloat(fraction.amount_fraction || 0),
          0,
        );
        return parseFloat(total.toFixed(2));
      }
      return 0;
    },
  },
  methods: {
    async getMotivosAdelantoSueldo() {
      try {
        const { data } = await MotivosAdelantoSueldoService.index();
        this.motivos_adelanto = data;
      } catch (error) {
        console.log(error);
      }
    },
    onDateChange(selectedDates, dateStr, instance) {
      // Cierra el calendario al seleccionar la fecha
      instance.close();
    },
    async getDiscountById() {
      try {
        const params = { id: this.modalData.id };
        const { data } = await DiscountsService.getDiscountById(params);

        console.log(data);
        this.form.area_id = data[0].area_id;
        this.form.employee_id = data[0].employee_id;
        this.form.discount_type_id = data[0].discount_type_id;
        this.form.observation = data[0].observation;
        this.form.total = data[0].total;
        await this.getEmployeeByArea(data[0].employee_id);
        this.form.quotas = data[0].quotas;
        this.form.sustentoUrl = data[0].sustento;

        // if (data[0].fractions != null) {
        //   this.form.fractions = data[0].fractions;
        // }
        let fracciones = data[0].fractions || [];

        if (fracciones != null) {
          console.log(fracciones);
          this.form.fractions = fracciones;
          this.$nextTick(() => {
            const formattedDate = moment(fracciones[0].payment_date).format(
              "DD-MM-YYYY",
            );
            this.form.fecha_primer_pago = moment(
              formattedDate,
              "DD-MM-YYYY",
            ).toDate();
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        // this.removePreloader();
      }
    },
    async getAdelantoById() {
      try {
        const params = { id: this.modalData.id };
        const { data } = await AdelantoService.show(params);
        this.form.area_id = data.area_id;
        this.form.employee_id = data.employee_id;
        this.form.discount_type_id = 2; // Adelanto de sueldo
        this.form.observation = data.observation;
        this.form.total = data.total;
        this.form.motivo_adelanto_id = data.id_motivo_adelanto;
        this.form.sustentoUrl = data.sustento;
        this.form.quotas = data.quotas;
        if (data.fractions != null) {
          this.form.fractions = data.fractions;
          this.$nextTick(() => {
            this.form.fecha_primer_pago = moment(
              data.fractions[0].formatted_date,
              "DD-MM-YYYY",
            ).toDate();
          });
        }

        console.log('Data del adelanto:', data);
        this.caja_automatica_data = {
          tipo_personal: data.tipo_personal,
          caja_motivo: data.caja_motivo,
          caja_submotivo: data.caja_submotivo,
        };

        await this.getEmployeeByArea(data.employee_id);
      } catch (error) {
        console.log(error);
        this.showToastError(error?.response?.data?.message);
      } finally {
        // this.removePreloader();
      }
    },
    toFormData(form) {
      const formData = new FormData();

      for (const key in form) {
        const value = form[key];

        if (key === "fractions") {
          // Protege de doble codificación
          if (typeof value === "string") {
            formData.append(key, value);
          } else {
            formData.append(key, JSON.stringify(value));
          }
        } else if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      }

      return formData;
    },
    async insertDiscount() {
      try {
        const result = await this.$refs["ref-validation-discount"].validate();
        if (result) {
          const confirm = await this.showConfirmSwal();
          if (confirm.isConfirmed) {
            this.addPreloader();
            this.form.user_id = this.currentUser.id;
            this.form.origin = this.localOrigin;

            let data;

            if (this.localOrigin === "adelanto") {
              let formData = this.toFormData(this.form);

              ({ data } = await AdelantoService.store(formData));
            } else {
              let formData = this.toFormData(this.form);

              ({ data } = await DiscountsService.insertDiscounts(formData));
            }

            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: this.$t(data.message),
                icon: "CoffeeIcon",
                variant: "success",
                text: this.$t(data.message),
              },
            });
            this.$emit("hideModal", true);
          }
        }
      } catch (error) {
        this.showToastError(error?.response?.data?.message);
      } finally {
        this.removePreloader();
      }
    },
    async approveDiscount() {
      try {
        const result = await this.$refs["ref-validation-discount"].validate();
        if (result) {
          if (this.form.total == 0) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Error",
                icon: "AlertCircleIcon",
                variant: "danger",
                text: "El monto no puede ser 0.",
              },
            });
            return;
          }

          const confirm = await this.showConfirmSwal();

          if (confirm.isConfirmed) {
            this.form.user_id = this.currentUser.id;

            let data;

            if (this.localOrigin === "adelanto") {
              
              const { isConfirmed } = await this.showConfirmSwal(
                "¿Desea generar caja automático en RosymarSoft?",
                "",
                {
                  confirmButtonText: "Si",
                  cancelButtonText: "No",
                },
              );

              this.form.caja_automatica = isConfirmed;
              this.form.origin = this.localOrigin;
              this.form.id_adelanto = this.modalData.id;

              if (isConfirmed) {
                const respuestaCajaAutomatica = await this.generarCajaAutomatica();
                console.log("Respuesta de caja automática:", respuestaCajaAutomatica);
              }

              ({ data } = await DiscountsService.approveDiscounts(this.form));

            } else {
              this.addPreloader();
              ({ data } = await DiscountsService.approveDiscounts(this.form));
            }

            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: this.$t(data.message),
                icon: "CoffeeIcon",
                variant: "success",
                text: this.$t(data.message),
              },
            });
            this.$emit("hideModal", true);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    async generarCajaAutomatica() {
      const personal = this.employees.find(
        (emp) => emp.id == this.form.employee_id,
      );

      const params = {
        origen: "adelanto_sueldo",
        user_id: this.currentUser.id,
        is_generate_payment: true,

        amount: this.form.total,
        personal_id: this.form.employee_id,
        nombre: personal.full_name,
        token: "sfgdshfiuhfgsd7w9t874w9erfhu54k435df",
        id_motivo: this.caja_automatica_data.caja_motivo,
        id_submotivo: this.caja_automatica_data.caja_submotivo,
        descripcion: this.form.observation,
      };

      const form_params = new URLSearchParams();
      form_params.append("data", JSON.stringify(params));
      return await viaticService.createCaja(form_params);
    },

    async anulleDiscount() {
      try {
        const result = await this.$refs["ref-validation-discount"].validate();
        if (result) {
          const confirm = await this.showConfirmSwal();
          if (confirm.isConfirmed) {
            this.addPreloader();
            this.form.user_id = this.currentUser.id;

            let data;

            if (this.localOrigin === "adelanto") {
              ({ data } = await AdelantoService.destroy(this.form));
            } else {
              ({ data } = await DiscountsService.anulleDiscount(this.form));
            }

            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: this.$t(data.message),
                icon: "CoffeeIcon",
                variant: "success",
                text: this.$t(data.message),
              },
            });
            this.$emit("hideModal", true);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async editDiscount() {
      try {
        const result = await this.$refs["ref-validation-discount"].validate();
        if (result) {
          const confirm = await this.showConfirmSwal();
          if (confirm.isConfirmed) {
            this.addPreloader();
            this.form.user_id = this.currentUser.id;

            let data;
            if (this.localOrigin === "adelanto") {
              let formData = this.toFormData(this.form);
              ({ data } = await AdelantoService.update(formData));
            } else {
              let formData = this.toFormData(this.form);
              ({ data } = await DiscountsService.editDiscounts(formData));
            }

            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: this.$t(data.message),
                icon: "CoffeeIcon",
                variant: "success",
                text: this.$t(data.message),
              },
            });
            this.$emit("hideModal", true);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async getAreas() {
      try {
        // this.addPreloader();
        const { data } = await EmployeeService.getAllAreas({
          moduleId: this.currentUser.modul_id,
        });
        this.areas = data;
      } catch (error) {
        console.log(error);
      } finally {
        // this.removePreloader();
      }
    },
    async getEmployeeByArea(employee_id = null) {
      if (employee_id == null) {
        this.form.employee_id = null;
      } else {
        this.form.employee_id = employee_id;
      }

      try {
        // this.addPreloader();
        const params = {
          area_id: this.form.area_id,
        };
        const { data } = await DiscountsService.getEmployeeByArea(params);
        this.employees = data;
      } catch (error) {
        console.log(error);
      } finally {
        // this.removePreloader();
      }
    },
    async getDiscountTypes() {
      try {
        // this.addPreloader();
        const { data } = await DiscountsService.getDiscountTypes();
        this.discount_types = data;
      } catch (error) {
        console.log(error);
      } finally {
        // this.removePreloader();
      }
    },
    calculateFractions() {
      if (this.suppressEvents) return;

      if (this.form.total > 0 && this.form.quotas > 0) {
        if (this.esAdelantoSueldo && !this.form.fecha_primer_pago) {
          console.warn("No se ha definido la fecha del primer pago.");
          return;
        }

        const total = this.form.total;
        const quotas = this.form.quotas;

        const fractions = [];

        // const start_date = this.esAdelantoSueldo
        //   ? moment(this.form.fecha_primer_pago, "DD-MM-YYYY")
        //   : moment().add(1, "months").date(5);
        const start_date = moment(this.form.fecha_primer_pago, "DD-MM-YYYY");

        const baseQuota = +(total / quotas).toFixed(2);
        let accumulated = 0;

        const originalDay = start_date.date(); // día original (ej. 31)

        for (let i = 0; i < quotas; i++) {
          let payment_date = moment(start_date).add(i, "months");

          // Asegurar que el día no exceda el último del mes
          const endOfMonth = payment_date.clone().endOf("month").date();
          const safeDay = Math.min(originalDay, endOfMonth);
          payment_date.date(safeDay);

          let amount_fraction;

          if (i === quotas - 1) {
            amount_fraction = +(total - accumulated).toFixed(2);
          } else {
            amount_fraction = baseQuota;
            accumulated += amount_fraction;
          }

          fractions.push({
            payment_date: payment_date.format("YYYY-MM-DD"),
            amount_fraction,
            formatted_date: payment_date.format("DD-MM-YYYY"),
          });
        }

        this.form.fractions = fractions;
      } else {
        this.form.fractions = [];
      }
    },
    async deleteSustento() {
      try {
        const { isConfirmed } = await this.showConfirmSwal();

        if (!isConfirmed) {
          return;
        }
        this.addPreloader();

        let data;

        if (this.localOrigin === "adelanto") {
          ({ data } = await AdelantoService.deleteSustento({
            id: this.modalData.id,
          }));
        } else {
          ({ data } = await DiscountsService.deleteSustento({
            id: this.modalData.id,
          }));
        }

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Éxito",
            icon: "CheckIcon",
            variant: "success",
            text: data.message,
          },
        });

        this.form.sustentoUrl = null;
      } catch (error) {
        console.error(error);
      } finally {
        this.removePreloader();
      }
    },
  },
  watch: {
    "form.discount_type_id": function (newValue) {
      if (newValue === 2) {
        this.localOrigin = "adelanto";
      }
    },
    "form.total"(newVal, oldVal) {
      if (this.suppressEvents) return;

      // Evita ejecutar si el cambio no es real
      if (newVal !== oldVal) {
        this.calculateFractions();
      }
    },
    "form.quotas"(newVal, oldVal) {
      if (this.suppressEvents) return;

      // Evita ejecutar si el cambio no es real
      if (newVal !== oldVal) {
        this.calculateFractions();
      }
    },

    "form.fecha_primer_pago"(newVal, oldVal) {
      if (this.suppressEvents) return;

      // Evita ejecutar si el cambio no es real
      if (newVal !== oldVal) {
        this.calculateFractions();
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
